import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        {
          type: 'regex',
          pattern:
            "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
          message: 'Please provide a valid email.'
        }
      ]
    },
    telNumber: {
      validations: [
        {
          type: 'regex',
          pattern:
            '[(]{0,1}[0-9]{3}[) ]{0,2}[-s.]{0,1}[0-9]{3}[-s.]{0,1}[0-9]{4}',
          message: 'Please provide a valid phone number.'
        }
      ]
    },
    addressLine1: {
      validations: []
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    postal: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    siteName: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    accountextra1: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'NAME',
            mapping: 'headerLabel',
            customClasses: ['heading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'First',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          },
          {
            type: 'label',
            size: 'Medium',
            label: 'Last',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL *',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'PHONE',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Address',
            mapping: 'headerLabel',
            customClasses: ['detailsheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Address',
            mapping: 'addressLine1',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Address Line 1',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'city',
            customClasses: ['no-label']
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State',
            options: [
              { label: 'Alabama', value: 'AL' },
              { label: 'Alaska', value: 'AK' },
              { label: 'Arizona', value: 'AZ' },
              { label: 'Arkansas', value: 'AR' },          
              { label: 'California', value: 'CA' },
              { label: 'Colorado', value: 'CO' },
              { label: 'Connecticut', value: 'CT' },
              { label: 'Delaware', value: 'DE' },
              { label: 'District of Columbia', value: 'DC' },
              { label: 'Florida', value: 'FL' },
              { label: 'Georgia', value: 'GA' },
              { label: 'Hawaii', value: 'HI' },
              { label: 'Idaho', value: 'ID' },
              { label: 'Illinois', value: 'IL' },
              { label: 'Indiana', value: 'IN' },
              { label: 'Iowa', value: 'IA' },
              { label: 'Kansas', value: 'KS' },
              { label: 'Kentucky', value: 'KY' },
              { label: 'Louisiana', value: 'LA' },
              { label: 'Maine', value: 'ME' },
              { label: 'Maryland', value: 'MD' },
              { label: 'Massachusetts', value: 'MA' },
              { label: 'Michigan', value: 'MI' },
              { label: 'Minnesota', value: 'MN' },
              { label: 'Mississippi', value: 'MS' },
              { label: 'Missouri', value: 'MO' },
              { label: 'Montana', value: 'MT' },
              { label: 'Nebraska', value: 'NE' },
              { label: 'Nevada', value: 'NV' },
              { label: 'New Hampshire', value: 'NH' },
              { label: 'New Jersey', value: 'NJ' },
              { label: 'New Mexico', value: 'NM' },
              { label: 'New York', value: 'NY' },
              { label: 'North Carolina', value: 'NC' },
              { label: 'North Dakota', value: 'ND' },
              { label: 'Ohio', value: 'OH' },
              { label: 'Oklahoma', value: 'OK' },
              { label: 'Oregon', value: 'OR' },
              { label: 'Pennsylvania', value: 'PA' },
              { label: 'Rhode Island', value: 'RI' },
              { label: 'South Carolina', value: 'SC' },
              { label: 'South Dakota', value: 'SD' },
              { label: 'Tennessee', value: 'TN' },
              { label: 'Texas', value: 'TX' },
              { label: 'Utah', value: 'UT' },
              { label: 'Vermont', value: 'VT' },
              { label: 'Virginia', value: 'VA' },
              { label: 'Washington', value: 'WA' },
              { label: 'West Virginia', value: 'WV' },
              { label: 'Wisconsin', value: 'WI' },
              { label: 'Wyoming', value: 'WY' }
            ],
            mapping: 'state',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'City',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          },
          {
            type: 'label',
            size: 'Medium',
            label: 'State',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code',
            mapping: 'postal',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Zip Code',
            mapping: 'headerLabel',
            customClasses: ['subheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'XLarge',
            label: 'Event Details',
            mapping: 'headerLabel',
            customClasses: ['detailsheading']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'NUMBER OF GUESTS',
            mapping: 'plannedguestcount'
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'DATE OF EVENT',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'OCCASION',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Cocktail Party', value: 'Cocktail Party' },
              { label: 'Business Luncheon', value: 'Business Luncheon' },
              { label: 'Breakfast', value: 'Breakfast' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'theme'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'EVENT LOCATION',
            mapping: 'siteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'HOW DID YOU HEAR ABOUT US?',
            options: [
              { label: 'Repeat Client', value: 'Repeat Client' },
              { label: 'Client Referral', value: 'Client Referral' },
              { label: 'Website', value: 'Website' },
              { label: 'Planner (Event, Caterer)', value: 'Planner' },
              { label: 'Owner Referral', value: 'Owner Referral' },
              { label: 'Employee Referral', value: 'Employee Referral' },
              { label: 'Mailing', value: 'Mailing' },
              { label: 'Cold Contact', value: 'Cold Contact' }
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'TELL US MORE ABOUT YOUR EVENT *',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'XLarge',
            label: 'WANT TO RECEIVE OUR EMAIL NEWSLETTER?',
            mapping: 'headerLabel',
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'XLarge',
            options: [
              { label: 'Sign me up!'  , value: 'Yes-Subscribe'},
            ],
            mapping: 'accountextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Send'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Anaviv Catering & Events Contact Us Form',
    formId: '511',
    clientKey: '3497498D-2D6F-47ED-862E-D53354B9653A',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText:
      'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/anaviv/form_structure.js